import { AjaxObservable } from './AjaxObservable';
export var ajax = AjaxObservable.create;
//# sourceMappingURL=ajax.js.map